export default __webpack_public_path__ + "static/media/profile.fc6610a0.svg";